'use client';

import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchFacetsJob } from '#/modules/search/constants/useSearchFacetsJob';
import {
  useSearchFiltersByName,
  useSearchQuery,
} from '#/modules/search/contexts/SearchContext';
import { searchShouldShowSortOptions } from '#/modules/search/helpers/searchShouldShowSortOptions';
import { SearchPage } from '#/modules/search/pages/Search/SearchPage';
import { trackPageView } from '#/utils/analytics/track/trackPageView';

export function SearchJobsPage() {
  const { i18n } = useI18n();

  const query = useSearchQuery();
  const filters = useSearchFiltersByName();

  const location = useLocation();
  useEffect(() => {
    trackPageView('Search Jobs');
  }, [location.key]);

  const { jobSearchFacets } = useSearchFacetsJob(i18n);

  return (
    <SearchPage
      searchFacets={jobSearchFacets}
      searchType="JOB"
      showSortOptions={searchShouldShowSortOptions({
        searchType: 'JOB',
        query,
        filters,
      })}
    />
  );
}
